import { List } from 'immutable'
import PropTypes from 'prop-types'
import { strings } from '../context/LanguageContext/strings'

export const promotionConstants = {
    addRemainingHeadCells: [
        {
            id: 'created_by',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CREATED_BY,
            draggable: true,
            width: '14%',
        },
        {
            id: 'updated_by',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_UPDATED_BY,
            draggable: true,
            width: '14%',
        },
        {
            id: 'created',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CREATED_AT,
            draggable: true,
            width: '14%',
        },
        {
            id: 'updated',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_UPDATED_AT,
            draggable: true,
            width: '14%',
        },
    ],
    getContentFiltersTemp: () => [
        {
            key: 'state',
            label: strings.REGION,
            after: 'comma',
        },
        {
            key: 'placement_location',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_FILTER_PLACEMENT,
            after: 'comma',
        },
        {
            key: 'language',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_TABLE_LANG,
            after: 'comma',
        },
        {
            key: 'status',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_FILTER_Status,
            after: 'comma',
        },
    ],
    getPlacements: () => [
        { value: 'Homepage Carousel', display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_CAROUSEL },
        { value: 'Deal Tile', display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_TILE },
    ],
    getNationals: () => [
        { value: 'United States', display: strings.UNITED_STATES },
        { value: 'Canada', display: strings.CANADA },
    ],
    getRegions,
    getStatusFields: () => [
        { value: 'live', display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_FIELD_LIVE },
        {
            value: 'finished',
            display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_FIELD_FINISHED,
        },
        {
            value: 'scheduled',
            display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_FIELD_SCHEDULED,
        },
        {
            value: 'incomplete',
            display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_FIELD_INCOMPLETE,
        },
    ],
    contentStatus: ['Complete', 'Incomplete'],
    getQaStatusFields: () => [
        { value: 'In QA Testing', display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_QA_IN },
        {
            value: 'Not In QA Testing',
            display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_QA_NOT,
        },
    ],
    getManageContentHeadCells: () => [
        {
            id: 'app',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_TABLE_APP,
            width: '10%',
            sortable: true,
        },
        {
            id: 'language',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_TABLE_LANG,
            width: '10%',
            sortable: true,
        },
        {
            id: 'placement_location',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_FILTER_PLACEMENT,
            width: '12%',
            sortable: true,
        },
        {
            id: 'region',
            label: strings.REGION,
            width: '12%',
            sortable: true,
        },
        {
            id: 'image',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_TABLE_IMG,
            width: '20%',
        },
        {
            id: 'timeInterval',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_TABLE_TIME,
            width: '16%',
        },
        {
            id: 'status',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_FILTER_Status,
            width: '12%',
            sortable: true,
        },
        {
            id: 'actions',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_TABLE_ACTIONS,
            width: '12%',
            align: 'left',
        },
    ],
    getMarketingStatusFields,
    getMarketingSteps: () => [
        {
            step: 0,
            name: 'content_languages',
            title: strings.CONTENT_LANGUAGES,
            value: 'content_languages',
        },
        {
            step: 1,
            name: 'placements',
            title: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_STEPS_PLACEMENTS,
            value: 'app',
        },
        {
            step: 2,
            name: 'schedule',
            title: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_STEPS_SCHEDULE,
            value: 'start_date',
        },
        {
            step: 3,
            name: 'audience',
            title: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_STEPS_AUDIENCE,
            value: 'region',
        },
        {
            step: 4,
            name: 'prioritization',
            title: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_STEPS_PRIORITIZATION,
            value: 'priority',
        },
        {
            step: 5,
            name: 'manageContent',
            title: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_STEPS_CONTENT,
            value: 'msg_input',
        },
    ],
    getPrioritizeContentHeadCells: () => [
        { id: 'radio', width: '5%' },
        {
            id: 'tier',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_TIER_HC,
            width: '7%',
        },
        {
            id: 'category',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_CATEGORY_HC,
            width: '16.66%',
        },
    ],
    getPrioritizationCategoriesList: () => [
        {
            id: 'free_LTO',
            value: 'Any FREE or LTO Offer',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_CAT_FREE,
            tier: 1,
        },
        {
            id: 'alcohol',
            value: 'Alcohol',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_CAT_ALCOHOL,
            tier: 2,
        },
        {
            id: 'freshFoods',
            value: 'Fresh Foods',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_CAT_FRESH,
            tier: 3,
        },
        {
            id: 'drinks_iceCream',
            value: 'Drinks, Ice Cream',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_CAT_DRINKS,
            tier: 4,
        },
        {
            id: 'candy',
            value: 'Candy',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_CAT_CANDY,
            tier: 5,
        },
        {
            id: 'other',
            value: 'Other',
            label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PRIORITIZATION_CAT_OTHER,
            tier: 6,
        },
    ],
    getManageContentFilter: () =>
        List([
            {
                type: 'list',
                key: 'placement_location',
                display_name:
                    strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_FILTER_PLACEMENT,
                display_value: [],
                post_value: [],
                defaultDisplayValue: [],
                defaultPostValue: [],
            },
            {
                type: 'list',
                key: 'language',
                display_name:
                    strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_TABLE_LANG,
                display_value: [],
                post_value: [],
                defaultDisplayValue: [],
                defaultPostValue: [],
            },
            {
                type: 'list',
                key: 'region',
                display_name: strings.REGION,
                display_value: [],
                post_value: [],
                displayPillUtil: list => {
                    const regions = getRegions()
                    return list?.map(
                        region => regions.find(({ value }) => value === region)?.display || region
                    )
                },
                defaultDisplayValue: [],
                defaultPostValue: [],
            },
            {
                type: 'list',
                key: 'status',
                display_name:
                    strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_FILTER_Status,
                display_value: [],
                post_value: [],
                displayPillUtil: list => {
                    const statuses = getMarketingStatusFields()
                    return list?.map(
                        status => statuses.find(({ value }) => value === status)?.display || status
                    )
                },
                defaultDisplayValue: [],
                defaultPostValue: [],
            },
        ]),
    promotionFilterLabels: [
        { key: 'name', label: strings.SEARCH },
        { key: 'createdBy', label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CREATED_BY, after: 'comma' },
        { key: 'lastModifiedBy', label: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MODIFIED, after: 'comma' },
        { key: 'promoSlin', label: strings.promoSlin, after: 'comma' },
        { key: 'marketingStatus', label: strings.marketingStatus, after: 'comma' },
        { key: 'publishedStatus', label: strings.publishedStatus, after: 'comma' },
        { key: 'date_range', label: strings.DATE, after: 'hyphen' },
    ],
    getPromotionModules: () => [
        { value: 'marketing', display: strings.SECTION_CREATE_NEW_PROMOTION_TYPE_MARKETING },
    ],
    getPromotionsHeadCells: () => [
        {
            id: 'name',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_TITLE,
            draggable: false,
            width: '13%',
        },
        {
            id: 'show_at',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_PLACEMENTS,
            draggable: true,
            width: '12%',
        },
        {
            id: 'start_date',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_DATE,
            draggable: true,
            width: '12%',
            sortable: true,
        },
        {
            id: 'state',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_AUDIENCE,
            draggable: true,
            width: '10%',
        },
        {
            id: 'priority',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_PRIORITY,
            draggable: true,
            width: '7%',
        },
        {
            id: 'status',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_STATUS,
            draggable: true,
            width: '12%',
            sortable: true,
        },
        // TODO: Hidden column for Hawaii MVP. Might be needed on future iterations
        // {
        //     id: 'qa_is_live',
        //     label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_QA,
        //     draggable: true,
        //     width: '9%',
        //     sortable: true,
        // },
        {
            id: 'is_live',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_PROD,
            draggable: true,
            width: '6%',
            sortable: true,
        },
        {
            id: 'action',
            label: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_ACTION,
            draggable: false,
            width: '5%',
        },
    ],
    getPublishedStatusFields: () => [
        {
            value: 'Published',
            display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_PRODUCTION_PUBLISHED,
        },
        {
            value: 'Unpublished',
            display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_PRODUCTION_UNPUBLISHED,
        },
    ],
    getSevenAppPlacementTiles: () => [
        {
            name: 'Homepage Carousel',
            title: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_APP_TILES_HOMEPAGE_CAROUSEL,
            width: 2058,
            height: 1020,
        },
        {
            name: 'Deal Tile',
            title: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_APP_TILES_DEAL_TILE,
            width: 2058,
            height: 1020,
        },
    ],
    getLandingPageType: () => [
        {
            value: 'None',
            display: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_PAGET_NONE,
        },
        {
            value: 'Category',
            display: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_PAGET_CATEGORY,
        },
        // TODO: Hidden option for Hawaii MVP. Might be needed on future iterations
        // {
        //     value: 'Product',
        //     display: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_PAGET_PRODUCT,
        // },
    ],
    publishStatusMap: {
        Published: true,
        Unpublished: false,
    },
    publishQAStatusMap: {
        In_QA_Testing: true,
        Not_In_QA_Testing: false,
    },
    publishContentAction: {
        qa_live: 'QA Testing',
        live: 'Publish to Production',
    },
    publishContentStatus: {
        true: 'enabled',
        false: 'disabled',
    },
    promoConfigPropType: PropTypes.arrayOf(
        PropTypes.shape({
            excludes: PropTypes.arrayOf(PropTypes.string),
            status: PropTypes.string,
            id: PropTypes.string,
            app: PropTypes.string,
            placement_location: PropTypes.string,
            region: PropTypes.shape({
                country: PropTypes.string,
                state: PropTypes.string,
            }),
            copy: PropTypes.string,
            legal_disclaimer: PropTypes.string,
            landing_page_name: PropTypes.string,
            landing_page_type: PropTypes.string,
            landing_page_id: PropTypes.string,
            image_url: PropTypes.string,
        })
    ),
    promoPropType: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
        is_live: PropTypes.bool,
        qa_is_live: PropTypes.bool,
        status: PropTypes.string,
        configurations: PropTypes.arrayOf(
            PropTypes.shape({
                excludes: PropTypes.arrayOf(PropTypes.string),
                status: PropTypes.string,
                id: PropTypes.string,
                app: PropTypes.string,
                placement_location: PropTypes.string,
                region: PropTypes.shape({
                    country: PropTypes.string,
                    state: PropTypes.string,
                }),
                copy: PropTypes.string,
                legal_disclaimer: PropTypes.string,
                landing_page_name: PropTypes.string,
                landing_page_type: PropTypes.string,
                landing_page_id: PropTypes.string,
                image_url: PropTypes.string,
            })
        ),
        schedule: PropTypes.object,
        created_by: PropTypes.string,
        created: PropTypes.string,
        updated_by: PropTypes.string,
        updated: PropTypes.string,
        type: PropTypes.arrayOf(PropTypes.string),
    }),
    notificationPropType: PropTypes.shape({
        andrd_acknowledged_count: PropTypes.number,
        andrd_disabled_count: PropTypes.number,
        andrd_failed_count: PropTypes.number,
        andrd_sent_count: PropTypes.number,
        broadcast_end: PropTypes.string,
        broadcast_start: PropTypes.string,
        broadcast_status: PropTypes.string,
        city: PropTypes.arrayOf(PropTypes.string),
        created: PropTypes.string,
        created_by: PropTypes.string,
        deepLinkURL: PropTypes.string,
        device_count: PropTypes.number,
        dma: PropTypes.arrayOf(PropTypes.string),
        endDate: PropTypes.string,
        ios_acknowledged_count: PropTypes.number,
        ios_disabled_count: PropTypes.number,
        ios_failed_count: PropTypes.number,
        ios_sent_count: PropTypes.number,
        message: PropTypes.string,
        scheduled: PropTypes.string,
        state: PropTypes.arrayOf(PropTypes.string),
        status: PropTypes.string,
        target: PropTypes.string,
        timezone: PropTypes.string,
        title: PropTypes.string,
        total_acknowledged_count: PropTypes.number,
        total_disabled: PropTypes.number,
        total_failed_count: PropTypes.number,
        total_sent_count: PropTypes.number,
        updated: PropTypes.string,
        updated_by: PropTypes.string,
        _id: PropTypes.string,
    }),
    getPromoLinkTitle: () => {
        return {
            value: 'Marketing / Content',
            display: strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_PROMO_LINK,
        }
    },
}

function getMarketingStatusFields() {
    return [
        { value: 'complete', display: strings.COMPLETE },
        { value: 'incomplete', display: strings.INCOMPLETE },
    ]
}

function getRegions() {
    return [{ value: 'National (US)', display: strings.SECTION_MANAGE_PROMOTIONS_FILTER_REGION_US }]
}
